import 'react-hot-loader/patch';
import 'reflect-metadata';
import '@shared/i18n';

import 'reset-css';
import 'font-awesome/css/font-awesome.min.css';

import DateFnsUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { QueryClientProvider } from '@tanstack/react-query';
import { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router-dom';

import { FieldsProvider } from '@agency/contexts/FieldsContext';
import { CombinedOptionsProvider } from '@agency/contexts/OptionsContext';
import { GlobalDrawerProvider } from '@agency/modules/requirements/pages/requirement-manage/pages/summary/components/GlobalDrawerProvider';
import { routeTitles } from '@agency/routes/routes.constant';
import { createTheme } from '@agency/theme/utils/create-theme';
import { AgreementModalOutlet } from '@shared/components/agreement-modal';
import { AppId, ConfigProvider } from '@shared/contexts/ConfigContext';
import { PusherProvider } from '@shared/contexts/PusherContext';
import { RouteProvider } from '@shared/contexts/RouteContext';
import { UnsavedChangesProvider } from '@shared/contexts/UnsavedChangesContext';
import store from '@shared/redux/store';
import { history } from '@shared/utils/history';
import { queryClient } from '@shared/utils/http-client';

import { App } from './App';

import '@shared/assets/scss/iconFonts.scss';
import '@shared/assets/scss/mapOverride.scss';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

const theme = createTheme();

render(
  <Router history={history}>
    <RouteProvider routeTitles={routeTitles}>
      <ThemeProvider theme={theme}>
        <ReduxProvider store={store}>
          <QueryClientProvider client={queryClient}>
            <AgreementModalOutlet />
            <ConfigProvider appId={AppId.Agency}>
              <PusherProvider>
                <UnsavedChangesProvider>
                  <CombinedOptionsProvider>
                    <FieldsProvider>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <GlobalDrawerProvider>
                          <App />
                        </GlobalDrawerProvider>
                      </MuiPickersUtilsProvider>
                    </FieldsProvider>
                  </CombinedOptionsProvider>
                </UnsavedChangesProvider>
              </PusherProvider>
            </ConfigProvider>
          </QueryClientProvider>
        </ReduxProvider>
      </ThemeProvider>
    </RouteProvider>
  </Router>,
  document.getElementById('root')
);
